import PropTypes from "prop-types";
import React from "react";

import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import currency from "../../util/currency-formatter";

const chargeSummaryLabels = {
  previous_balance: "Previous Balance",
  current_charges: "Current Charges",
  payments_adjustments: "Payments & Adjustment",
  prior_period_charges: "Prior Period Charges",
  taxes_fees: "Taxes Fees"
};

function namify(key) {
  return key
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

const StatementDetailsRow = (props) => {
  const { summary } = props;
  const { charge_summary } = summary;

  const createDetailRow = (key, name) => {
    // Charge item - show total only if a breakdown is not available
    let chargeItem = [
      <TableRow key={key}>
        <TableCell />
        <TableCell align="left" style={{ fontWeight: "bold" }}>
          {name}
        </TableCell>
        <TableCell colSpan={9} align="left">
          {!summary[key] && currency(charge_summary[key])}
        </TableCell>
      </TableRow>,
    ];

    // Display charge item breakdown if available
    if (summary[key]) {
      let chargeItemBreakdown = summary[key].map((detail, index) => {
        return (
          <TableRow key={index}>
            <TableCell />
            <TableCell style={{ paddingLeft: 25 }} align="left">
              {detail?.item}
            </TableCell>
            <TableCell colSpan={9} align="left">
              {currency(detail?.amount)}
            </TableCell>
          </TableRow>
        );
      });
      // Charge item total
      let chargeItemTotal = [
        <TableRow key={key}>
          <TableCell />
          <TableCell align="left">
            {`Total ${name}`}
          </TableCell>
          <TableCell colSpan={9} align="left">
            {currency(charge_summary[key])}
          </TableCell>
        </TableRow>,
      ];
      return [chargeItem, ...chargeItemBreakdown, chargeItemTotal];
    } else {
      return chargeItem;
    }
  };

  return summary.hasOwnProperty("charge_summary") ? (
    [ // Process known items first to maintain ordering
      ...Object.keys(chargeSummaryLabels).map((charge) => {
        return createDetailRow(charge, chargeSummaryLabels[charge]);
      }),
      ...Object.keys(charge_summary).filter((key) => key !== "total_due" && !chargeSummaryLabels[key]).map((charge) => {
        return createDetailRow(charge, namify(charge));
      }),
      createDetailRow("total_due", "Total Due")
    ]
  ) : (
    <TableRow>
      <TableCell></TableCell>
      <TableCell colSpan={9}>
        Summary Breakdown Not Available For This Statement
      </TableCell>
    </TableRow>
  );
};

StatementDetailsRow.propTypes = {
  summary: PropTypes.object.isRequired,
};

export default StatementDetailsRow;
